import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Pages/AuthLayout";
import Login from "@/pages/Pages/Login";
import TriviaContents from "@/pages/Trivia/TriviaContents";

const Dashboard = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Dashboard");

const TopicContents = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Topics/TopicContents");
const TopicDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Topics/TopicDetail");

const ChitchatContents = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Chitchats/ChitchatContents");
const ChitchatDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Chitchats/ChitchatDetail");

const FanLogs = () => import("@/pages/FanLog/FanLogs");
const HotFanLogs = () => import("@/pages/FanLog/HotFanLogs");
const HotTags = () => import("@/pages/FanLog/HotTags");
const FanLogDetail = () => import("@/pages/FanLog/FanLogDetail");
const Challenges = () => import("@/pages/FanLog/Challenges");
const ChallengeDetail = () => import("@/pages/FanLog/ChallengeDetail");

const CommentContents = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Comments/CommentContents");
const ContentCommentsPage = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Comments/ContentCommentsPage");
const QuickComments = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Comments/QuickComments");

const Today = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Today/Today.vue");
const Viewer = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Viewer/Viewer.vue");
const ViewerRank = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Viewer/ViewerRank.vue");

const BlipArtist = () => import(/* webpackChunkName: "dashboard" */ "@/pages/BlipArtist/BlipArtist.vue");
const BlipArtistDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/BlipArtist/BlipArtistDetail.vue");
const BlipArtistNames = () => import(/* webpackChunkName: "dashboard" */ "@/pages/BlipArtist/BlipArtistNames.vue");
const BlipArtistMemberNames = () => import(/* webpackChunkName: "dashboard" */ "@/pages/BlipArtist/BlipArtistMemberNames.vue");
const BlipArtistSuggestion = () => import(/* webpackChunkName: "dashboard" */ "@/pages/BlipArtist/BlipArtistSuggestion.vue");
const BlipArtistBlackKeyword = () => import(/* webpackChunkName: "dashboard" */ "@/pages/BlipArtist/BlipArtistBlackKeyword.vue");
const BlipArtistCategories = () => import(/* webpackChunkName: "dashboard" */ "@/pages/BlipArtist/BlipArtistCategories.vue");
const BlipArtistCategoryDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/BlipArtist/BlipArtistCategoryDetail.vue");

const Poll = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Poll/Poll.vue");
const PollDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Poll/PollDetail.vue");
const PollCasts = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Poll/PollCasts.vue");
const FundingDefaultTemplate = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Poll/FundingDefaultTemplate.vue");
const RewardWidget = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Poll/RewardWidget.vue");
const RewardWidgetForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Poll/RewardWidgetForm.vue");
const FundingRequest = () => import(/* webpackChunkName: "dashboard" */ "@/pages/FundingRequest/FundingRequest.vue");

const Banner = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Banner/Banner.vue");
const BannerForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Banner/BannerForm.vue");
const EventBanner = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Banner/EventBanner.vue");
const EventBannerForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Banner/EventBannerForm.vue");
const Popup = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Banner/Popup.vue");
const PopupForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Banner/PopupForm.vue");
const EventBannerGroup = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Banner/EventBannerGroup.vue");
const EventBannerGroupForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Banner/EventBannerGroupForm.vue");

const Template = () => import(/* webpackChunkName: "dashboard" */ "@/pages/TemplateManage/Template.vue");
const TemplateForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/TemplateManage/TemplateForm.vue");

const Quest = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Quest/Quest.vue");
const QuestForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Quest/QuestForm.vue");

const HomeQuest = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Quest/Home/Sites.vue");
const HomeQuestForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Quest/Home/SiteForm.vue");

const Site = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Quest/Site/Site.vue");
const SiteForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Quest/Site/SiteForm.vue");
const PhotoCard = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Quest/PhotoCard/PhotoCard.vue");
const PhotoCardForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Quest/PhotoCard/PhotoCardForm.vue");
const Category = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Quest/Category/Category.vue");
const CategoryForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Quest/Category/CategoryForm.vue");

const Thread = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Thread/Thread.vue");
const ThreadForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Thread/ThreadForm.vue");

const StanningLog = () => import(/* webpackChunkName: "dashboard" */ "@/pages/MyPage/StanningLog.vue");
const StanningLogDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/MyPage/StanningLogDetail.vue");

const ArtistBoard = () => import(/* webpackChunkName: "dashboard" */ "@/pages/ArtistBoard/ArtistBoard.vue");
const ArtistBoardSuggestion = () => import(/* webpackChunkName: "dashboard" */ "@/pages/ArtistBoard/ArtistBoardSuggestion.vue");
const IpdokCollection = () => import(/* webpackChunkName: "dashboard" */ "@/pages/ArtistBoard/IpdokCollection.vue");

const Collections = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Collection/Collections.vue");
const CollectionForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Collection/CollectionForm.vue");
const CollectionPool = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Collection/CollectionPool.vue");
const CollectionDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Collection/CollectionDetail.vue");
const CollectionHashTags = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Collection/CollectionHashTags.vue");
const CollectionHashTagManage = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Collection/CollectionHashTagManage.vue");

const Notice = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Notice/Notice.vue");
const NoticeDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Notice/NoticeDetail.vue");

const Terms = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Terms/Terms.vue");
const TermsForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Terms/TermsForm.vue");
const TermsVersions = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Terms/TermsVersions.vue");

const FAQ = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Faq/Faq.vue");
const FaqDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Faq/FaqDetail.vue");

const Language = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Language/Language.vue");

const Invitation = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Event/Invitation.vue");

const Homepage = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Homepage/Homepage.vue");
const SharePage = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Homepage/SharePage.vue");
const HomepageBanner = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Homepage/Banner.vue");
const HomepageBannerForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Homepage/BannerForm.vue");
const HomepageSite = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Homepage/Sites.vue");
const HomepageSiteForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Homepage/SiteForm.vue");
const HomepageCommunity = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Homepage/Community.vue");
const HomepageCommunityDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Homepage/CommunityDetail.vue");
const HomepageCommunityComment = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Homepage/CommunityComment.vue");

const Inquery = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Inquery/Inquery.vue");
const InqueryDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Inquery/InqueryDetail.vue");

const AdminUserManage = () => import(/* webpackChunkName: "dashboard" */ "@/pages/AdminUser/AdminUserManage.vue");
const AdminUserManageForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/AdminUser/AdminUserManageForm.vue");

const UserManage = () => import(/* webpackChunkName: "dashboard" */ "@/pages/User/UserManage.vue");
const UserDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/User/UserDetail.vue");
const NicknameBlackKeyword = () => import(/* webpackChunkName: "dashboard" */ "@/pages/User/NicknameBlackKeyword.vue");

const Schedule = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Schedules/Schedule.vue");
const HotSchedulePool = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Schedules/HotSchedulePool.vue");
const ScheduleForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Schedules/ScheduleForm.vue");
const ScheduleSuggestion = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Schedules/ScheduleSuggestion.vue");
const ScheduleSuggestionForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Schedules/ScheduleSuggestionForm.vue");
const ScheduleNotificationType = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Schedules/ScheduleNotificationType.vue");
const ScheduleNotificationTypeForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Schedules/ScheduleNotificationTypeForm.vue");

const LabKeywords = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Labs/LabKeywords.vue");
const ArtistKeywords = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Labs/ArtistKeywords.vue");

const Radars = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Radar/RadarContents.vue");
const RadarDetail = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Radar/RadarContentDetail.vue");
const ArtistChannelManage = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Radar/ArtistChannelManage.vue");

const NotificationTemplate = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Notifications/NotificationTemplate.vue");
const ReservedNotification = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Notifications/ReservedNotification.vue");
const NotificationTemplateForm = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Notifications/NotificationTemplateForm.vue");

const Report = () => import(/* webpackChunkName: "reports" */ "@/pages/Reports/ReportContents.vue");

const CustomNotification = () => import(/* webpackChunkName: "reports" */ "@/pages/Notifications/CustomNotification.vue");
const CustomChatNotification = () => import(/* webpackChunkName: "reports" */ "@/pages/Notifications/CustomChatNotification.vue");
const AppFile = () => import(/* webpackChunkName: "reports" */ "@/pages/FileManage/AppFile.vue");
const Subscription = () => import(/* webpackChunkName: "reports" */ "@/pages/Payment/Subscription.vue");

let collectionMenu = {
  path: "/collection",
  component: DashboardLayout,
  redirect: "/collection/collections",
  name: "Collection",
  children: [
    {
      path: "collections",
      name: "갤러리",
      components: { default: Collections },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "collectionForm",
      name: "갤러리 작성",
      components: { default: CollectionForm },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "collectionPool",
      name: "갤러리 풀",
      components: { default: CollectionPool },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "collectionDetail",
      name: "갤러리 상세",
      components: { default: CollectionDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "collectionHashTags",
      name: "갤러리 해시태그",
      components: { default: CollectionHashTags },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "collectionHashTagManage",
      name: "갤러리 해시태그 관리",
      components: { default: CollectionHashTagManage },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let fanLogMenu = {
  path: "/fanLog",
  component: DashboardLayout,
  redirect: "/fanLog/fanLogs",
  name: "FAN LOG",
  children: [
    {
      path: "fanLogs",
      name: "팬로그",
      components: { default: FanLogs },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "fanLogDetail",
      name: "팬로그 상세",
      components: { default: FanLogDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "hotFanLogs",
      name: "인기 팬로그풀",
      components: { default: HotFanLogs },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "hotTags",
      name: "인기 팬로그 태그",
      components: { default: HotTags },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "challenges",
      name: "챌린지",
      components: { default: Challenges },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "challengeDetail",
      name: "챌린지 상세",
      components: { default: ChallengeDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let artistBoardMenu = {
  path: "/artistBoard",
  component: DashboardLayout,
  redirect: "/artistBoard/artistBoard",
  name: "ArtistBoard",
  children: [
    {
      path: "artistBoard",
      name: "아티스트보드",
      components: { default: ArtistBoard },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "artistBoardSuggestion",
      name: "아티스트보드 제안",
      components: { default: ArtistBoardSuggestion },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "ipdokCollection",
      name: "입덕갤러리",
      components: { default: IpdokCollection },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let todayMenu = {
  path: "/today",
  component: DashboardLayout,
  redirect: "/today/today",
  name: "Today",
  children: [
    {
      path: "today",
      name: "투데이 관리",
      components: { default: Today },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let viewerMenu = {
  path: "/viewer",
  component: DashboardLayout,
  redirect: "/viewer",
  name: "Viewer",
  children: [
    {
      path: "/viewer",
      name: "케이팝나우",
      components: { default: Viewer },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "/viewer/rank",
      name: "케이팝나우",
      components: { default: ViewerRank },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let blipArtistMenu = {
  path: "/blipArtist",
  component: DashboardLayout,
  redirect: "/blipArtist/blipArtist",
  name: "BlipArtist",
  children: [
    {
      path: "blipArtist",
      name: "아티스트 관리",
      components: { default: BlipArtist },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "blipArtistDetail",
      name: "아티스트 상세",
      components: { default: BlipArtistDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "blipArtistNames",
      name: "아티스트 이름",
      components: { default: BlipArtistNames },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "blipArtistMemberNames",
      name: "아티스트 멤버 이름",
      components: { default: BlipArtistMemberNames },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "blipArtistSuggestion",
      name: "아티스트 제안",
      components: { default: BlipArtistSuggestion },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "blipArtistBlackKeyword",
      name: "아티스트 블랙키워드",
      components: { default: BlipArtistBlackKeyword },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "blipArtistCategories",
      name: "아티스트 카테고리",
      components: { default: BlipArtistCategories },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "blipArtistCategoryDetail",
      name: "아티스트 카테고리 상세",
      components: { default: BlipArtistCategoryDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let pollMenu = {
  path: "/poll",
  component: DashboardLayout,
  redirect: "/poll/list",
  name: "Poll",
  children: [
    {
      path: "/poll/list",
      name: "투표 관리",
      components: { default: Poll },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "/poll/detail",
      name: "투표 상세",
      components: { default: PollDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "/poll/casts",
      name: "유저 투표 현황",
      components: { default: PollCasts },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "/poll/default-template",
      name: "기본 템플릿",
      components: { default: FundingDefaultTemplate },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "/poll/rewards",
      name: "리워드 위젯 관리",
      components: { default: RewardWidget },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "/poll/rewardForm",
      name: "리워드 위젯 상세",
      components: { default: RewardWidgetForm },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let fundingRequestMenu = {
  path: "/fundingRequest",
  component: DashboardLayout,
  redirect: "/fundingRequest/list",
  name: "FundingRequest",
  children: [
    {
      path: "list",
      name: "서포트 요청",
      components: { default: FundingRequest },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let noticeMenu = {
  path: "/notices",
  component: DashboardLayout,
  redirect: "/notices/notice",
  name: "Notice",
  children: [
    {
      path: "notice",
      name: "공지사항",
      components: { default: Notice },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "noticeDetail",
      name: "공지사항 상세",
      components: { default: NoticeDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let termsMenu = {
  path: "/terms",
  component: DashboardLayout,
  redirect: "/terms/list",
  name: "Terms",
  children: [
    {
      path: "list",
      name: "약관/방침 관리",
      components: { default: Terms },
      meta: { roles: ["admin"] },
    },
    {
      path: ":id/edit",
      name: "약관/방침 편집",
      components: { default: TermsForm },
      meta: { roles: ["admin"] },
    },
    {
      path: ":id/versions",
      name: "약관/방침 버전 이력",
      components: { default: TermsVersions },
      meta: { roles: ["admin"] },
    },
  ],
};

let faqMenu = {
  path: "/faqs",
  component: DashboardLayout,
  redirect: "/faqs/faq",
  name: "FAQ",
  children: [
    {
      path: "faq",
      name: "FAQ 목록",
      components: { default: FAQ },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "faqDetail",
      name: "FAQ 상세",
      components: { default: FaqDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let inqueryMenu = {
  path: "/inqueries",
  component: DashboardLayout,
  redirect: "/inqueries/inquery",
  name: "1:1고객문의",
  children: [
    {
      path: "inquery",
      name: "1:1 고객문의",
      components: { default: Inquery },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "inqueryDetail",
      name: "1:1 고객문의 상세",
      components: { default: InqueryDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let userMenu = {
  path: "/user",
  component: DashboardLayout,
  redirect: "/user/userManage",
  name: "유저관리",
  children: [
    {
      path: "userManage",
      name: "유저 관리",
      components: { default: UserManage },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "userDetail",
      name: "유저 상세",
      components: { default: UserDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "nickname/blackList",
      name: "블랙리스트 관리",
      components: { default: NicknameBlackKeyword },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let adminUserMenu = {
  path: "/adminUser",
  component: DashboardLayout,
  redirect: "/adminUser/adminUserManage",
  name: "운영자관리",
  children: [
    {
      path: "adminUserManage",
      name: "운영자 목록",
      components: { default: AdminUserManage },
      meta: { roles: ["admin"] },
    },
    {
      path: "adminUserManageForm",
      name: "운영자 관리",
      components: { default: AdminUserManageForm },
      meta: { roles: ["admin"] },
    },
  ],
};

let scheduleMenu = {
  path: "/schedules",
  component: DashboardLayout,
  redirect: "/schedules/schedules",
  name: "Schedule",
  children: [
    {
      path: "schedules",
      name: "스케줄",
      components: { default: Schedule },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "scheduleForm",
      name: "스케줄 상세",
      components: { default: ScheduleForm },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "scheduleSuggestion",
      name: "스케줄 제보",
      components: { default: ScheduleSuggestion },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "scheduleSuggestionForm",
      name: "스케줄 제보 상세",
      components: { default: ScheduleSuggestionForm },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "scheduleNotificationType",
      name: "스케줄 알림 타입",
      components: { default: ScheduleNotificationType },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "scheduleNotificationTypeForm",
      name: "스케줄 알림 타입",
      components: { default: ScheduleNotificationTypeForm },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "hotSchedulePool",
      name: "인기 스케줄 풀",
      components: { default: HotSchedulePool },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let labMenu = {
  path: "/labs",
  component: DashboardLayout,
  redirect: "/labs/keywords",
  name: "Lab",
  children: [
    {
      path: "keywords",
      name: "인기키워드 관리",
      components: { default: LabKeywords },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "artistKeywords",
      name: "아티스트키워드 설정",
      components: { default: ArtistKeywords },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let triviaMenu = {
  path: "/trivia",
  component: DashboardLayout,
  redirect: "/trivia/triviaContents",
  name: "Trivia",
  children: [
    {
      path: "triviaContents",
      name: "TMI 관리",
      components: { default: TriviaContents },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let threadMenu = {
  path: "/thread",
  component: DashboardLayout,
  redirect: "/thread/thread",
  name: "Thread",
  children: [
    {
      path: "thread",
      name: "불판 관리",
      components: { default: Thread },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "threadForm",
      name: "불판 추가",
      components: { default: ThreadForm },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

let bannerMenu = {
  path: "/banner",
  component: DashboardLayout,
  redirect: "/banner/banner",
  name: "Banner",
  children: [
    {
      path: "banner",
      name: "아티스트 배너 관리",
      components: { default: Banner },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "bannerForm",
      name: "아티스트 배너 추가",
      components: { default: BannerForm },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "eventBanner",
      name: "이벤트 배너 관리",
      components: { default: EventBanner },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "eventBannerForm",
      name: "이벤트 배너 추가",
      components: { default: EventBannerForm },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "popup",
      name: "팝업 관리",
      components: { default: Popup },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "popupForm",
      name: "팝업 추가",
      components: { default: PopupForm },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "eventBannerGroup",
      name: "아티스트별 배너 그룹",
      components: { default: EventBannerGroup },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "eventBannerGroupForm",
      name: "아티스트별 배너 그룹 수정",
      components: { default: EventBannerGroupForm },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

const myPageMenu = {
  path: "/myPage",
  component: DashboardLayout,
  redirect: "/myPage/stanningLog",
  children: [
    {
      path: "stanningLog",
      name: "덕질 기록",
      components: { default: StanningLog },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "stanningLogDetail",
      name: "덕질 기록 상세",
      components: { default: StanningLogDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

const radarMenu = {
  path: "/radars",
  component: DashboardLayout,
  redirect: "/radars/radarContents",
  children: [
    {
      path: "radarContents",
      name: "트렌드",
      components: { default: Radars },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "radarContentDetail",
      name: "트렌드 상세",
      components: { default: RadarDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "artistChannelManage",
      name: "아티스트 채널 관리",
      components: { default: ArtistChannelManage },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

const topicMenu = {
  path: "/topic",
  component: DashboardLayout,
  redirect: "/topic/contents",
  children: [
    {
      path: "contents",
      name: "토픽",
      components: { default: TopicContents },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "detail/:topicId",
      name: "토픽 상세",
      components: { default: TopicDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

const chitchatMenu = {
  path: "/chitchat",
  component: DashboardLayout,
  redirect: "/chitchat/contents",
  children: [
    {
      path: "contents",
      name: "잡담",
      components: { default: ChitchatContents },
      meta: { roles: ["admin", "contentAdmin"] },
    },
    {
      path: "detail/:chitchatId",
      name: "잡담 상세",
      components: { default: ChitchatDetail },
      meta: { roles: ["admin", "contentAdmin"] },
    },
  ],
};

const commentMenu = {
  path: "/comment",
  component: DashboardLayout,
  redirect: "/comment/contents",
  children: [
    {
      path: "contents",
      name: "댓글 조회",
      components: { default: CommentContents },
    },
    {
      path: "/comment/all",
      name: "컨텐트 댓글",
      components: { default: ContentCommentsPage },
    },
    {
      path: "/comment/quickComments",
      name: "퀵코멘트",
      components: { default: QuickComments },
    },
  ],
};

const authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "login",
      name: "login",
      component: Login,
    },
  ],
};

const routes = [
  {
    path: "/",
    redirect: "/today/today",
    name: "투데이",
  },
  {
    path: "/dashboard",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "/",
        name: "대시보드",
        components: { default: Dashboard },
      },
    ],
  },
  {
    path: "/invitation",
    component: DashboardLayout,
    redirect: "/event",
    children: [
      {
        path: "/event/invitation",
        name: "친구초대",
        components: { default: Invitation },
      },
    ],
  },
  todayMenu,
  viewerMenu,
  blipArtistMenu,
  pollMenu,
  fundingRequestMenu,
  bannerMenu,
  collectionMenu,
  fanLogMenu,
  noticeMenu,
  termsMenu,
  faqMenu,
  inqueryMenu,
  userMenu,
  adminUserMenu,
  scheduleMenu,
  labMenu,
  threadMenu,
  triviaMenu,
  artistBoardMenu,
  radarMenu,
  topicMenu,
  chitchatMenu,
  commentMenu,
  myPageMenu,
  authPages,
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "/reports",
        name: "신고",
        components: { default: Report },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/template",
        name: "템플릿 관리",
        components: { default: Template },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/quest",
        name: "퀘스트 관리",
        components: { default: Quest },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/quest/questForm",
        name: "퀘스트 수정",
        components: { default: QuestForm },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/quest/site",
        name: "사이트 관리",
        components: { default: Site },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/quest/siteForm",
        name: "사이트 수정",
        components: { default: SiteForm },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/home/site",
        name: "투데이 미션 관리",
        components: { default: HomeQuest },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/home/siteForm",
        name: "투데이 미션 수정",
        components: { default: HomeQuestForm },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/quest/photoCard",
        name: "포토카드 관리",
        components: { default: PhotoCard },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/quest/photoCardForm",
        name: "포토카드 수정",
        components: { default: PhotoCardForm },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/quest/category",
        name: "카테고리",
        components: { default: Category },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/quest/categoryForm",
        name: "카테고리 수정",
        components: { default: CategoryForm },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/notification/template",
        name: "알림템플릿",
        components: { default: NotificationTemplate },
        meta: { roles: ["admin"] },
      },
      {
        path: "/notification/reservedNotification",
        name: "알림템플릿",
        components: { default: ReservedNotification },
        meta: { roles: ["admin"] },
      },
      {
        path: "/notification/templateForm",
        name: "알림템플릿 작성",
        components: { default: NotificationTemplateForm },
        meta: { roles: ["admin"] },
      },
      {
        path: "/template/templateForm",
        name: "템플릿 작성하기",
        components: { default: TemplateForm },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/language",
        name: "언어설정",
        components: { default: Language },
        meta: { roles: ["admin", "languageAdmin"] },
      },
      {
        path: "/homepage",
        name: "홈페이지 관리",
        components: { default: Homepage },
        meta: { roles: ["admin"] },
      },
      {
        path: "/homepage/sharePage",
        name: "공유페이지 관리",
        components: { default: SharePage },
        meta: { roles: ["admin"] },
      },
      {
        path: "/homepage/banner",
        name: "홈페이지 배너 관리",
        components: { default: HomepageBanner },
        meta: { roles: ["admin"] },
      },
      {
        path: "/homepage/bannerForm",
        name: "홈페이지 배너상세",
        components: { default: HomepageBannerForm },
        meta: { roles: ["admin"] },
      },
      {
        path: "/homepage/sites",
        name: "홈페이지 사이트 관리",
        components: { default: HomepageSite },
        meta: { roles: ["admin"] },
      },
      {
        path: "/homepage/siteForm",
        name: "홈페이지 사이트 상세",
        components: { default: HomepageSiteForm },
        meta: { roles: ["admin"] },
      },
      {
        path: "/homepage/community",
        name: "홈페이지 커뮤니티 관리",
        components: { default: HomepageCommunity },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/homepage/community/detail",
        name: "홈페이지 커뮤니티 상세",
        components: { default: HomepageCommunityDetail },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/homepage/community/comment",
        name: "홈페이지 커뮤니티 댓글 관리",
        components: { default: HomepageCommunityComment },
        meta: { roles: ["admin", "contentAdmin"] },
      },
      {
        path: "/notification/CustomNotification",
        name: "알림 전송",
        components: { default: CustomNotification },
        meta: { roles: ["admin"] },
      },
      {
        path: "/notification/CustomChatNotification",
        name: "채팅 전송",
        components: { default: CustomChatNotification },
        meta: { roles: ["admin"] },
      },
      {
        path: "/fileManage/appFile",
        name: "앱 설정파일 관리",
        components: { default: AppFile },
        meta: { roles: ["admin"] },
      },
      {
        path: "/payment/subscription",
        name: "구독 관리",
        components: { default: Subscription },
        meta: { roles: ["admin"] },
      },
    ],
  },
];

export default routes;
